import script from "./CvTileClickable.vue?vue&type=script&setup=true&lang=js"
export * from "./CvTileClickable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__